/* eslint-disable react/jsx-no-target-blank */

import { useContext } from 'react'
import roleContext from '../../../../app/context/roleContext'
import { useAuth } from '../../../../app/modules/auth'
import { RoleContextValue } from '../../../../app/types/OtherTypes'
import { checkRole } from '../../../helpers'
import { FEATURE_KEYS } from '../../../../app/features/featureRegistry'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'

export function AsideMenuMain() {
  let roleState: RoleContextValue = useContext(roleContext)
  const { currentUser } = useAuth()

// Role checks
  // Role checks
  // const isSuperAdmin =
  //   roleState.roleName === 'Super Admin' ||
  //   roleState.roleName === 'SUPER_ADMIN'

  //=========
  // const isSuperAdmin =
  // roleState.roleName?.trim().toUpperCase().replace(/_/g, ' ') === 'SUPER ADMIN'
  // const isRmOrHr = currentUser?.isRmOrHr || false
  // const isProjectManager = currentUser?.isProjectManager || false
  // const isAdmin =
  // roleState.roleName?.toLowerCase() === 'admin'

  //=========
  const normalizedRoleName = roleState.roleName?.trim().toUpperCase().replace(/_/g, ' ')
  const isSuperAdmin = normalizedRoleName === 'SUPER ADMIN'
  const isAdmin = normalizedRoleName === 'ADMIN'
  // const isHr = normalizedRoleName === 'HR' || normalizedRoleName.startsWith('HR ')
  const isRmOrHr = currentUser?.isRmOrHr || false
  const isPerformanceStaff = isSuperAdmin || isAdmin || isRmOrHr
  const isProjectManager = currentUser?.isProjectManager || false
 
  console.log('===== SIDEBAR AMS DEBUG =====', {
    roleName: roleState.roleName,
    isSuperAdmin,
    isAdmin,
    isRmOrHr,
    features: roleState.features,
    amsPermission: checkRole(
      ['attendance_management_system'],
      roleState.features
    ),
  })

  // return (
  //   <>
  //     {/* Dashboard */}
  //     {checkRole(['dashboard'], roleState.features) && (
  //       <AsideMenuItem
  //         title='Dashboard'
  //         to='/dashboard'
  //         fontIcon='bi bi-speedometer2 fs-2'
  //         bsTitle='Dashboard'
  //         className='py-2'
  //       />
  //     )}

  //     {/* AMS */}
  //     {checkRole(['attendance_management_system'], roleState.features) && (
  //       <AsideMenuItem
  //         to='/ams'
  //         title='AMS'
  //         fontIcon='bi-house fs-2'
  //         bsTitle='AMS'
  //         className='py-2'
  //       />
  //     )}
        
  //     {/* Hiring */}
  //     {/* {(isSuperAdmin || isRmOrHr ||
  //       checkRole(
  //         [
  //           FEATURE_KEYS.hiring_access,
  //           FEATURE_KEYS.hiring_view_applications,
  //         ],
  //         roleState.features
  //       )) && (
  //         <AsideMenuItem
  //           to='/hiring/jobs'
  //           title='Hiring'
  //           fontIcon='bi bi-briefcase'
  //           bsTitle='Hiring'
  //           className='py-2'
  //         />
  //       )} */}
  //       {/* Hiring */}
  //       {(isSuperAdmin || isRmOrHr || isAdmin) &&
  //         checkRole(
  //           [
  //             FEATURE_KEYS.hiring_access,
  //             FEATURE_KEYS.hiring_view_applications,
  //           ],
  //           roleState.features
  //         ) && (
  //           <AsideMenuItem
  //             to='/hiring/jobs'
  //             title='Hiring'
  //             fontIcon='bi bi-briefcase'
  //             bsTitle='Hiring'
  //             className='py-2'
  //           />
  //         )}


  //     {/* LMS */}
  //     {checkRole(['leave_management_system', 'leave_audit'], roleState.features) && (
  //       <AsideMenuItem
  //         to='/leave'
  //         title='LMS'
  //         fontIcon='bi-house-check'
  //         bsTitle='LMS'
  //         className='py-2'
  //       />
  //     )}

  //     {/*  Dept Master (HR & Admin ONLY) */}
  //     {/* {(isSuperAdmin ||
  //       roleState.roleName === 'Admin' ||
  //       (currentUser?.designation?.name || '')
  //         .toUpperCase()
  //         .includes('HR')) && (
  //         <AsideMenuItem
  //           to='/dept-master'
  //           title='Department Master'
  //           fontIcon='bi bi-diagram-3 fs-2'
  //           bsTitle='Department Master'
  //           className='py-2'
  //         />
  //       )} */}
  //       {/*  Dept Master (HR & Admin ONLY) */}
  //         {(isSuperAdmin ||
  //           isAdmin ||
  //           (currentUser?.designation?.name || '')
  //             .toUpperCase()
  //             .includes('HR')) && (
  //             <AsideMenuItem
  //               to='/dept-master'
  //               title='Department Master'
  //               fontIcon='bi bi-diagram-3 fs-2'
  //               bsTitle='Department Master'
  //               className='py-2'
  //             />
  //         )}
  //     {/* Projects */}
  //     {isProjectManager && currentUser?.role?.name !== 'PARTNER' &&  (
  //       <AsideMenuItem
  //         to='/projects'
  //         title='Projects'
  //         fontIcon='bi bi-folder-fill fs-2'
  //         bsTitle='Project Management'
  //         className='py-2'
  //       />
  //     )}

  //     {/* Timesheet - Accessible to ALL users */}
  //     <AsideMenuItem
  //       to='/timesheet/dashboard'
  //       title='Timesheet'
  //       fontIcon='bi-clock-history'
  //       bsTitle='Timesheet'
  //       className='py-2'
  //     />


  //     {/* Users */}
  //     {(isSuperAdmin || isRmOrHr || isAdmin ) &&
  //       checkRole(
  //         ['users_registration', 'roles', 'designations'],
  //         roleState.features
  //       ) && (
  //         <AsideMenuItem
  //           to='/users'
  //           title='Users'
  //           fontIcon='bi-person fs-2'
  //           bsTitle='Users'
  //           className='py-2'
  //         />
  //       )}

  //     {/* Shift Management (SEPARATE PAGE – FIXED) */}
  //     {(isSuperAdmin || isRmOrHr || isAdmin) &&
  //       checkRole(
  //         ['users_registration', 'roles', 'designations'],
  //         roleState.features
  //       ) && (
  //         <AsideMenuItem
  //           to='/shift-management'
  //           title='Shift'
  //           fontIcon='bi bi-calendar-check fs-2'
  //           bsTitle='ShiftManagement'
  //           className='py-4'
  //         />
  //       )}

  //     {/*  Attendance Edit Approvals (HR / RM / Admin / Super Admin ONLY) */}
  //     {/* {checkRole(['attendance_management_system'], roleState.features) &&
  //       (isSuperAdmin || isRmOrHr || isAdmin) && (
  //         <AsideMenuItem
  //           to='/ams/edit-approvals'
  //           title='Attendance Approvals'
  //           fontIcon='bi bi-check2-square fs-2'
  //           bsTitle='Attendance Edit Approvals'
  //           className='py-2'
  //         />
  //     )} */}
  //     {( isSuperAdmin || isAdmin ||
  //       (isRmOrHr && checkRole(['attendance_management_system'], roleState.features))
  //     ) && (
  //       <AsideMenuItem
  //         to='/ams/edit-approvals'
  //         title='Attendance Approvals'
  //         fontIcon='bi bi-check2-square fs-2'
  //         bsTitle='Attendance Edit Approvals'
  //         className='py-2'
  //       />
  //     )}
      
  //     {/* Holidays */}
  //     {checkRole(['holidays'], roleState.features) && (
  //       <AsideMenuItem
  //         to='/holidays'
  //         title='Holidays'
  //         fontIcon='bi bi-umbrella'
  //         bsTitle='Policy'
  //         className='py-2'
  //       />
  //     )}
  //     {/*  Location Master */}
  //     {(isSuperAdmin || isRmOrHr || isAdmin) &&
  //       checkRole(
  //         ['users_registration', 'roles', 'designations'],
  //         roleState.features
  //       ) && (
  //         <AsideMenuItem
  //           to='/location-management'
  //           title='Location'
  //           fontIcon='bi bi-geo-alt-fill fs-2'
  //           bsTitle='Location Master'
  //           className='py-4'
  //         />
  //       )}

      

  //     {/* Assets */}
  //     {/* {(isSuperAdmin ||
  //       roleState.roleName === 'Admin' ||
  //       (currentUser?.designation?.name || '')
  //         .toUpperCase()
  //         .includes('HR')) &&
  //       checkRole(['asset_management_system'], roleState.features) && (
  //         <AsideMenuItem
  //           to='/assets'
  //           title='Assets'
  //           fontIcon='bi bi-motherboard'
  //           bsTitle='Assets'
  //           className='py-2'
  //         />
  //     )} */}
  //     {/* Assets */}
  //     {(
  //       roleState.roleName === 'Super Admin' ||
  //       roleState.roleName?.toLowerCase() === 'admin' ||
  //       checkRole(['asset_management_system'], roleState.features)
  //     ) && (
  //       <AsideMenuItem
  //         to='/assets'
  //         title='Assets'
  //         fontIcon='bi bi-motherboard'
  //       />
  //     )}

  //     {/* Reports */}
  //     {/* {checkRole(['reports'], roleState.features) && (
  //       <AsideMenuItem
  //         to='/reports'
  //         title='Reports'
  //         fontIcon='bi bi-files'
  //         bsTitle='Reports'
  //         className='py-2'
  //       />
  //     )} */}
  //     {/* Reports */}
  //     {(
  //       isSuperAdmin ||
  //       isAdmin ||
  //       checkRole(['reports'], roleState.features)
  //     ) && (
  //       <AsideMenuItem
  //         to='/reports'
  //         title='Reports'
  //         fontIcon='bi bi-files'
  //         bsTitle='Reports'
  //         className='py-2'
  //       />
  //     )}
  //     {/* Settings */}
  //     {(isSuperAdmin || isAdmin) &&
  //       checkRole(
  //         [
  //           'leave_config',
  //           'general_config',
  //           FEATURE_KEYS.settings_leave_type,
  //           FEATURE_KEYS.settings_leave_policy,
  //         ],
  //         roleState.features
  //       ) && (
  //         <AsideMenuItem
  //           to='/setting'
  //           title='Setting'
  //           fontIcon='bi-gear fs-2'
  //           bsTitle='Setting'
  //           className='py-2'
  //         />
  //       )}
        
  //   </>
  // )


  

  return (
    <>
      {/* Dashboard */}
      {checkRole(['dashboard'], roleState.features) && (
        <AsideMenuItem
          title='Dashboard'
          to='/dashboard'
          fontIcon='bi bi-speedometer2 fs-2'
          bsTitle='Dashboard'
          className='py-3'
        />
      )}

      {/* AMS */}
      {/* AMS */}
      {checkRole(['attendance_management_system'], roleState.features) && (
        <AsideMenuItemWithSub
          to="/ams"
          title="AMS"
          fontIcon="bi-house fs-2"
        >
          <AsideMenuItem
            to="/ams"
            title="Attendance Dashboard"
            fontIcon="bi bi-speedometer2 fs-2"
            hasBullet={true}
          />

          {(isSuperAdmin ||
            isAdmin ||
            (isRmOrHr &&
              checkRole(['attendance_management_system'], roleState.features))) && (
            <AsideMenuItem
              to="/ams/edit-approvals"
              title="Attendance Approval"
              fontIcon="bi bi-check2-square fs-2"
              hasBullet={true}
            />
          )}
        </AsideMenuItemWithSub>
      )}

      {/* LMS */}
      {checkRole(['leave_management_system', 'leave_audit'], roleState.features) && (
        <AsideMenuItem
          to='/leave'
          title='LMS'
          fontIcon='bi-house-check'
          bsTitle='LMS'
          className='py-3'
        />
      )}

      {/* Holidays */}
      {/* {checkRole(['holidays'], roleState.features) && (
        <AsideMenuItem
          to='/holidays'
          title='Holidays'
          fontIcon='bi bi-umbrella'
          bsTitle='Holidays'
          className='py-3'
        />
      )}  */}

      {/* Work Management */}
      {checkRole(['timesheet_access'], roleState.features) && (
        <AsideMenuItemWithSub
          to="/work-management"
          title="Workspace"
          fontIcon="bi-briefcase fs-2"
        >
          <AsideMenuItem
            to="/timesheet/dashboard"
            title="Timesheet"
            fontIcon="bi-clock-history fs-2"
          />

          {/* {isProjectManager && currentUser?.role?.name !== 'PARTNER' && (
            <AsideMenuItem
              to="/projects"
              title="Projects"
              fontIcon="bi-folder-fill fs-2"
            />
          )} */}
          {(
            isSuperAdmin ||
            isAdmin ||
            (isProjectManager && currentUser?.role?.name !== 'PARTNER')
          ) && (
            <AsideMenuItem
              to="/projects"
              title="Projects"
              fontIcon="bi-folder-fill fs-2"
            />
          )}
        </AsideMenuItemWithSub>
      )}

      {/* Organization Setup */}
      {(isSuperAdmin || isRmOrHr || isAdmin) &&
        checkRole(
          ['users_registration', 'roles', 'designations'],
          roleState.features
        ) && (
        <AsideMenuItemWithSub
          to="/organization-setup"
          title="Organization"
          fontIcon="bi-building fs-2"
        >
          {/* Users */}
          {(
            isSuperAdmin ||
            (
              (isRmOrHr || isAdmin) &&
              checkRole(
                ['users_registration', 'roles', 'designations'],
                roleState.features
              )
            )
          ) && (
            <AsideMenuItem
              to="/users"
              title="Users"
              fontIcon="bi-person fs-2"
            />
          )}

          {/* Department Master */}
          {(
            isSuperAdmin ||
            isAdmin ||
            (currentUser?.designation?.name || '')
              .toUpperCase()
              .includes('HR')
          ) && (
            <AsideMenuItem
              to="/dept-master"
              title="Department Master"
              fontIcon="bi-diagram-3 fs-2"
            />
          )}

          {/* Location */}
          {(
            isSuperAdmin ||
            (
              (isRmOrHr || isAdmin) &&
              checkRole(
                ['users_registration', 'roles', 'designations'],
                roleState.features
              )
            )
          ) && (
            <AsideMenuItem
              to="/location-management"
              title="Location"
              fontIcon="bi-geo-alt-fill fs-2"
            />
          )}
        </AsideMenuItemWithSub>
      )}


      {/* Employee Services */}
      {checkRole(['hiring_access'], roleState.features) && (
        <AsideMenuItemWithSub
          to="/employee-services"
          title="Employee Services"
          fontIcon="bi-people fs-2"
        >
        <div className="mt-4">
          {/* {(isSuperAdmin || isRmOrHr || isAdmin) &&
            checkRole(
              [
                FEATURE_KEYS.hiring_access,
                FEATURE_KEYS.hiring_view_applications,
              ],
              roleState.features
            ) && (
              <AsideMenuItem
                to="/hiring/jobs"
                title="Hiring"
                fontIcon="bi-briefcase fs-2"
              />
            )} */}
            {(
              isSuperAdmin ||
              (
                (isRmOrHr || isAdmin) &&
                checkRole(
                  [
                    FEATURE_KEYS.hiring_access,
                    FEATURE_KEYS.hiring_view_applications,
                  ],
                  roleState.features
                )
              )
            ) && (
              <AsideMenuItem
                to="/hiring/jobs"
                title="Hiring"
                fontIcon="bi-briefcase fs-2"
              />
            )}

          {checkRole(['holidays'], roleState.features) && (
            <AsideMenuItem
              to="/holidays"
              title="Holidays"
              fontIcon="bi-umbrella fs-2"
            />
          )}
        </div>
      </AsideMenuItemWithSub>
      )}

      {/* Shift Management (SEPARATE PAGE – FIXED) */}
      {(isSuperAdmin || isRmOrHr || isAdmin) &&
        checkRole(
          ['users_registration', 'roles', 'designations'],
          roleState.features
        ) && (
          <AsideMenuItem
            to='/shift-management'
            title='Shift'
            fontIcon='bi bi-calendar-check fs-2'
            bsTitle='ShiftManagement'
            className='py-3'
          />
      )}
      {/* Assets */}
      {(
        isSuperAdmin ||
        isAdmin ||
        checkRole(['asset_management_system'], roleState.features)
      ) && (
        <AsideMenuItem
          to='/assets'
          title='Assets'
          fontIcon='bi bi-motherboard'
          className='py-3'
        />
      )}

      {/* Incident Management - Accessible to all users */}
      <AsideMenuItem
        to='/incident'
        title='Incident'
        fontIcon='bi bi-exclamation-triangle fs-2'
        bsTitle='Incident Management'
        className='py-3'
      />
      {/* Performance Module */}
      <AsideMenuItemWithSub to="/performance" title="Performance" fontIcon="bi-person-check fs-2" className="performance-menu">
            {(isSuperAdmin || isAdmin || isRmOrHr) && <AsideMenuItem to="/performance" title="Dashboard" fontIcon="bi bi-speedometer2" />}
            {(isSuperAdmin || isAdmin || isRmOrHr) && <AsideMenuItem to="/performance/review-cycles" title="Review Cycles" fontIcon="bi-calendar3" />}
            <AsideMenuItem to="/performance/goals" title={isPerformanceStaff ? 'Goals' : 'My Goals'} fontIcon="bi-list-task" />
            <AsideMenuItem to="/performance/feedback" title={isPerformanceStaff ? 'Feedback' : 'My Feedback'} fontIcon="bi-chat-left-text" />
            <AsideMenuItem to="/performance/appraisals" title={isPerformanceStaff ? 'Appraisals' : 'My Appraisal'} fontIcon="bi-award" />
        </AsideMenuItemWithSub>
      {/* Reports */}
      {(
        isSuperAdmin ||
        isAdmin ||
        checkRole(['reports'], roleState.features)
      ) && (
        <AsideMenuItem
          to='/reports'
          title='Reports'
          fontIcon='bi bi-files'
          bsTitle='Reports'
          className='py-3'
        />
      )}
      {/* Settings */}
      {(isSuperAdmin || isAdmin) &&
        checkRole(
          [
            'leave_config',
            'general_config',
            FEATURE_KEYS.settings_leave_type,
            FEATURE_KEYS.settings_leave_policy,
          ],
          roleState.features
        ) && (
          <AsideMenuItem
            to='/setting'
            title='Setting'
            fontIcon='bi-gear fs-2'
            bsTitle='Setting'
            className='py-3'
          />
      )}
    </>
  )
}
